import { Grid } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import UniversalToolBarWithDialogs from "../../../bar/UniversalToolBarWithDialogs";
import LoaderWrapper from "../../../wrapper/LoaderWrapper";
import FilterTable from "../../../table/FilterTable";
import useHRService from "../../../../services/hrService";
import { useAsync } from "../../../../hooks/useAsync";
import usePaginationWithSearchParams from "../../../../hooks/usePaginationWithSearchParams";
import useLocalData from "../../../../hooks/useLocalData";
import { useEmptyArrayMemo } from "../../../../hooks/useEmptyArrayMemo";
import TableService from "../../../../services/tableService";
import { hrAnswerRegistryExportUrl } from "../../../../helpers/apiUrls";
import { ANSWER_TABLE_FIELDS_CONFIG, ANSWER_TABLE_NAME } from "./TabTablesConfig";
import { useTranslation } from "react-i18next";



export default function AnswerRegistryTab(props) {
  const { t } = useTranslation();

  const { pageName } = props;

  const TABLE_CONFIGS = [
    { name: ANSWER_TABLE_NAME, config: ANSWER_TABLE_FIELDS_CONFIG },
  ];

  const [hiddenColumnsForTables, setHiddenColumnsForTables] = useState([]);
  const [columnsOrdersForTables, setColumnsOrdersForTables] = useState([]);

  const {
    getAnswerRegistryList,
    getAnswerFilteringData
  } = useHRService();

  const filteringData = useAsync(getAnswerFilteringData)

  const { emptyArrayMemo } = useEmptyArrayMemo()


  const {
    page: answerPage,
    pageSize: answerPageSize,
    handleChangePageWithSearchParams: handleChangeAnswerPage,
    handleChangePageSizeWithSearchParams: handleChangeAnswerPageSize,
    resetPageNumber: resetAnswerPageNumber,
    searchParams: answerSearchParams,
    setSearchParams,
    onClearSearchParams: onClear
  } = usePaginationWithSearchParams(undefined, { 'page_size': 100 }, 100);


  

    useEffect(() => {
        const newSearchParams = new URLSearchParams(answerSearchParams);
        newSearchParams.set('page_size', answerPageSize|| 100);
        setSearchParams(newSearchParams)
    }, [answerSearchParams,]);

  const {
    data: answerData,
    dataCount,
    dataLoading,
    dataRefetch,
    tableData: answerTableData
  } = useLocalData(getAnswerRegistryList, answerSearchParams, true, undefined, ANSWER_TABLE_FIELDS_CONFIG, hiddenColumnsForTables?.[ANSWER_TABLE_NAME], columnsOrdersForTables?.[ANSWER_TABLE_NAME]);

  const answerExportHeaders = useMemo(() => {
    return TableService.getTableExportHeaders(
      ANSWER_TABLE_FIELDS_CONFIG,
      hiddenColumnsForTables?.[ANSWER_TABLE_NAME],
      columnsOrdersForTables?.[ANSWER_TABLE_NAME]
    );
  }, [
    ANSWER_TABLE_FIELDS_CONFIG,
    hiddenColumnsForTables,
    columnsOrdersForTables
  ]);


  return (

        <Grid
          container
          item
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          rowSpacing={1}
        >
          <Grid item xs={12} marginY={1}>
            <UniversalToolBarWithDialogs
              pageName={pageName}
              tableConfig={TABLE_CONFIGS}
              filteringData={filteringData ?? {}}
              refreshTable={dataRefetch}
              resetPageNumber={resetAnswerPageNumber}
              hiddenColumnsForTables={hiddenColumnsForTables}
              setHiddenColumnsForTables={setHiddenColumnsForTables}
              columnsOrdersForTables={columnsOrdersForTables}
              setColumnsOrdersForTables={setColumnsOrdersForTables}
              showMassActionButton={false}
              showOpenCloseFilterButton={false}
              showCleanfiltersButton={true}
              showMyFiltersButton={true}
              showSearchButton={true}
              cleanFiltersFn={onClear}
              showCreateButton={false}
              mdGridButton={2.75}
            />
          </Grid>
          <Grid item xs={12}>
            <LoaderWrapper showLoader={answerData === undefined || filteringData.loading}>
              <FilterTable
                data={answerTableData}
                showCheckbox={false}
                showCleanFilterIcon={true}
                countRecords={dataCount}
                page={answerPage}
                onPageChange={handleChangeAnswerPage}
                rowsPerPage={answerPageSize}
                onRowsPerPageChange={handleChangeAnswerPageSize}
                resetPageNumber={resetAnswerPageNumber}
                filteringData={filteringData}
                style={{ maxHeight: "vh" }}
                tableConfig={ANSWER_TABLE_FIELDS_CONFIG}
                showContextMenu={false}
                headersConfig={TableService.getHeadersConfigForCollapsibleTable(
                  ANSWER_TABLE_FIELDS_CONFIG,
                  filteringData || emptyArrayMemo,
                  hiddenColumnsForTables ? hiddenColumnsForTables[ANSWER_TABLE_NAME] : emptyArrayMemo,
                  columnsOrdersForTables ? columnsOrdersForTables[ANSWER_TABLE_NAME] : emptyArrayMemo,
                )}
                showExportToFileButton={true}
                exportToFileUrl={hrAnswerRegistryExportUrl}
                exportToFileSearchParams={answerSearchParams}
                exportToFileHeaders={answerExportHeaders}
                exportToFileFileName={`${t(
                  "tabs.answer_registry_tab.answer_registry"
                ).replace(" ", "_")}.xlsx`}
                isLoading={dataLoading}
              />
            </LoaderWrapper>
          </Grid>
        </Grid>

  );
}
